import React, { useEffect } from 'react'
import axios from 'axios';
export default function Filter(props) {
    const check = async () => {
        let div1 = '';
        let div2 = '';
        let div3 = '';
        let div4 = '';
        let div5 = '';
        let query = {}
        if (props.for == 'user') {
            query.location = div1 = document.getElementById('Fname').value;
            query.specalization = div2 = document.getElementById('Lname').value;
            query.experiance = div3 = document.getElementById('Iemail').value;
        } else {
            div1 = document.getElementById('FPname').value;
            div2 = document.getElementById('FDate').value;
            div3 = document.getElementById('FDDate').value;
            div4 = document.getElementById('FStatus').value;
            console.log(div1)
            query = {
                project_name: div1.length == 0 ? 0 : parseInt(div1.split(' ').pop()),
                date: div2.length == 0 ? '' : div2,
                due_date: div3,
                status: div4,
            }
        }
        var form_data = new FormData();
        for (var key in query) {
            form_data.append(key, query[key]);
        }
        let notify = document.getElementsByClassName('noti')[0];
        if (div1 != '' || div2 != '' || div3 != '' || div3 != '')
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/${props.url}`,
                data: form_data,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(async response => {
                console.log(div3.id)
                props.data(response.data)
                if (response.data.length == 0) {
                    notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        No Users Found
                    </div>`;
                } else {
                    notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                    ${response.data.length} Users Found
                </div>`;
                }
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);

            }).catch(err => {
                console.log(err)
            })
        else props.get()
        if (props.for == 'user') {
            props.setFil({
                first_name: div1.length == 0 ? null : 'Location : ' + div1,
                last_name: div2.length == 0 ? null : 'Specialization : ' + div2,
                email: div3.length != 0 ? 'Experience : ' + div3 : null,
            })
        } else if (props.for == 'invoice') {
            console.log('div2 is ', div2, div4)
            props.setFil({
                project_name: div1.length == 0 ? null : 'project name : ' + div1,
                date: div2 == '' ? null : 'date : ' + div2,
                due_date: div3 == '' ? null : 'due date : ' + div3,
                status: div4 == '' ? null : 'status : ' + div4,
            })
        }
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'ACCOUNTANT' ? 'account/projects/' : type == 'CONSULTANT' ? 'consultant/projects/' : 'project/projects/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                await response.data.map((e) => {
                    document.getElementById('projdrop').innerHTML +=
                        `<option value='${e.id}'>${e.project_name}</option>`
                })
            }).catch(err => {
                console.log(err)
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
            })
    }
    let type = localStorage.getItem('type');
    function clear(id) {
        console.log('got a hit')
        document.getElementById(id).value = '';
        check();
        return;
    }
    props.childFunc.clear = clear;
    let countries = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
        "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
        "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
        "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad",
        "Chile", "China", "Colombi", "Comoros", "Congo (Brazzaville)", "Congo", "Costa Rica", "Cote d'Ivoire", "Croatia",
        "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor (Timor Timur)",
        "Ecuador", "Egypt", "El Salvador", "Europe", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France",
        "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
        "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
        "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait",
        "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
        "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
        "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar", "Namibia",
        "Nauru", "Nepa", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau",
        "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
        "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe",
        "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
        "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
        "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
        "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
        "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"]
    return (
        <div className='showdet filter showfil'>
            <div className='sticky'></div>
            <div className='sticky2'>
                <div className='projDetI inputfix Projects'>
                    <i onClick={() => {
                        // document.getElementsByClassName('showfil')[0].style.display = 'none' }} 
                        document.getElementsByClassName('showfil')[0].classList.remove('show_hide')
                    }}
                        style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                    {props.for == 'user' ?
                        <>
                            <div> <span>Location  </span>
                                <select id='Fname'>
                                    <option value="">SELECT</option>
                                    <option value='India'> India </option>
                                    {
                                        Object.keys(countries).map((item) => (
                                            <option value={countries[item]}> {countries[item]} </option>
                                        ))
                                    }
                                </select>
                                {/* <input id='Fname' placeholder='type...' /> */}
                            </div>
                            <div> <span>Specialization   </span>
                                <select id='Lname'>
                                    <option value="">SELECT</option>
                                    <option value="records review">Records Review</option>
                                    <option value="physical">Physical</option>
                                    <option value="other">Other</option>
                                </select>
                                {/* <input id='Lname' placeholder='type...' /> */}
                            </div>
                            <div> <span>Experience </span>
                                <select id='Iemail'>
                                    <option value="">SELECT</option>
                                    <option value="<1">&lt;1</option>
                                    <option value="<3">&lt;3</option>
                                    <option value="<5">&lt;5</option>
                                    <option value="<8">&lt;8</option>
                                    <option value="<15">&lt;15</option>
                                </select>
                                {/* <input id='Iemail' placeholder='type...' /> */}
                            </div>
                        </> : props.for == 'invoice' ?


                            <>
                                <div> <span>Project Name  </span>
                                    {/* <select id='optPnam'>
                            <option value="none">SELECT</option>
                        </select> */}
                                    <input id='FPname' list="Pnames" placeholder='type name...' />
                                    <datalist id="Pnames">

                                    </datalist>
                                </div>
                                <div> <span>Date   </span>
                                    {/* <select id='optPmem'>
                            <option value="none">SELECT</option>
                        </select> */}
                                    <input id='FDate' type='date' placeholder='type...' />
                                </div>
                                <div> <span>Due Date </span>
                                    <select id='FDDate'>
                                        <option value="">SELECT</option>
                                        <option value="IMMEDIATE">IMMEDIATE</option>
                                        <option value="N15">N15</option>
                                        <option value="N30">N30</option>
                                        <option value="N45">N45</option>
                                        <option value="N60">N60</option>
                                    </select>
                                </div>
                                <div> <span>Status </span>
                                    <select id='FStatus'>
                                        <option value="">SELECT</option>
                                        <option value="APPROVED">APPROVED</option>
                                        <option value="APPROVED_PAID">APPROVED_PAID</option>
                                        <option value="REJECTED">REJECTED</option>
                                        <option value="NOTUPDATED">NOTUPDATED</option>
                                    </select>
                                </div>
                            </> : <></>
                    }
                    <button className='filter-apply' onClick={() => { check(); document.getElementsByClassName('showfil')[0].classList.remove('show_hide') }}> Apply </button>

                </div>
            </div>
        </div>
    )
}
